module.exports = __webpack_public_path__ + "static/img/3906c0cb01eb05f98a5dfd441676b980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon3(3).png
// module id = AMW6
// module chunks = 1